// eslint-disable-next-line
import checkboxStyle from './checkbox-style.module.css';

const Checkbox = ({ id, name, large, value, indeterminate, checked, disabled, onChange, className = '' }) => {
    const calcCheckboxStyle = () => {
        if (large) {
            const style = 'h-6 w-6 ';

            if (indeterminate) {
                return style + checkboxStyle.largeIndeterminate;
            }

            if (checked) return style + checkboxStyle.largeChecked;

            return style;
        } else {
            const style = 'h-4 w-4 ';

            if (indeterminate) {
                return style + checkboxStyle.smallIndeterminate;
            }

            if (checked) return style + checkboxStyle.smallChecked;

            return style;
        }
    };

    const calcBackground = () => {
        let style = '';

        if (checked || indeterminate) {
            if (disabled) {
                style = 'bg-sf-primary-200';
            } else {
                style = 'bg-sf-primary-500';
            }
        } else {
            if (disabled) {
                style = 'bg-sf-gray-100 border-2';
            } else {
                style = 'bg-sf-white border-2';
            }
        }

        return style;
    };

    return (
        <input
            className={`${
                disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            } mt-0 flex justify-center items-center appearance-none border-sf-gray-300 focus:outline-none rounded ${calcBackground()} ${calcCheckboxStyle()}`}
            type="checkbox"
            disabled={disabled || ''}
            id={id}
            name={name || ''}
            checked={checked || indeterminate || false}
            onChange={() => onChange(value)}
        />
    );
};

export default Checkbox;
